
import * as YupLib from 'yup';
export const yup = YupLib;


// ===========================
// FORM - YUP UTILS
// ===========================
YupLib.addMethod(YupLib.mixed, 'sameAs', function (ref, message) {
  return this.test('sameAs', message, function (value) {
    let other = this.resolve(ref);
    return !other || !value || value === other;
  })
})



// ===========================
// VALIDATORS
// ===========================
export const validatePassword = yup
  .string()
  .required()
  .min(6)
  .max(20)
  .trim();

export const validateRepeatPassword = yup
  .string()
  .required()
  .trim()
  .sameAs(yup.ref('password'), 'Passwords do not match')

export const validateEmail = yup
  .string()
  .min(5)
  .trim()
  .email();